export const pieCodes = {
  'hxt001': 'Hxt001',
  'hxt002': 'Hxt002',
  'hxt003': 'Hxt003',
  'hxt004': 'Hxt004',
  'hxt005': 'Hxt005',
  'bt001': 'Bt001',
  'bt002': 'Bt002',
  'bt003': 'Bt003',
  'bt004': 'Bt004',
  'bt005': 'Bt005',
}

export const top = (type = 'hxt') => {
  return {
    series: [{
      center: ['50%', '50%'],
      radius: type === 'hxt' ? ['48%', '65%'] : '65%'
    }],
    title: [
      {
        x: 'center',
        y: 'center',
        textStyle: {
          lineHeight: 10,
        }
      },
    ]
  }
}

export const left = (type = 'hxt') => {
  return {
    series: [{
      center: ['50%', '50%'],
      radius: type === 'hxt' ? ['48%', '65%'] : '65%',
    }],
    title: [
      {
        x: 'center',
        y: 'center',
        textStyle: {
          lineHeight: 10,
        }
      },
    ]
  }
}

export const codesConfig = {
  [pieCodes.hxt001]: {
    ...top()
  },
  [pieCodes.hxt002]: {
    ...top()
  },
  [pieCodes.hxt003]: {
    ...left()
  },
  [pieCodes.hxt004]: {
    ...left()
  },
  [pieCodes.hxt005]: {
    ...left()
  },
  // 铺满pie
  [pieCodes.bt001]: {
    ...top('bt')
  },
  [pieCodes.bt002]: {
    ...top('bt')
  },
  [pieCodes.bt003]: {
    ...left('bt')
  },
  [pieCodes.bt004]: {
    ...left('bt')
  },
  [pieCodes.bt005]: {
    ...left('bt')
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/pie/config.js